// Define minimum width where navigation should be shown
export const MIN_WIDTH_FOR_MOBILE = 1000;
export const MIN_WIDTH_FOR_MOBILE_LARGER = 1100;

// Subscription plans layout (SubscriptionPlans, SubscriptionPlanCard)
export const SUBSCRIPTION_PLAN_CARD_MIN_WIDTH = 306;
export const SUBSCRIPTION_PLAN_CARD_MAX_WIDTH = 350;
export const SUBSCRIPTION_PLANS_GAP = 24;
